import { onBeforeUnmount, watch } from 'vue'
import { useBackDismiss } from './useBackDismiss'

/**
 * Closes a temporary `v-navigation-drawer` on Escape and on the browser's back button — Android's
 * included — as a sheet closes (docs/plans/mobile-navigation.md, "Gestures, focus and screen
 * readers"). Vuetify's drawer does neither: it closes when the route changes, so back left the page
 * under it. Here back closes the drawer and the page stays.
 *
 * An Escape meant for a dialog opened over the drawer is left to that dialog.
 */
export function useDrawerDismiss(isOpen: () => boolean, close: () => void) {
  useBackDismiss(isOpen, close)

  function onKeydown(event: KeyboardEvent) {
    if (event.key !== 'Escape' || !isOpen()) return
    if (event.target instanceof Element && event.target.closest('.v-overlay')) return
    close()
  }

  function stop() {
    document.removeEventListener('keydown', onKeydown)
  }

  watch(isOpen, (open) => (open ? document.addEventListener('keydown', onKeydown) : stop()), { immediate: true })
  onBeforeUnmount(stop)
}
